export default __webpack_public_path__ + "static/media/The Agony of Ages.09a9ed53.jpg";